import { Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { selectSchoolId } from "../../../redux/slices/auth.slice";
import SwitchSchedule from "../../admin/pages/components/manageschedule/SwitchSchedule";
import useGroupBranchOptions from "../useGroupBranchOptions";
import useGroupBranchSwitch from "../useGroupBranchSwitch";

const SCHEDULE_PATH = "/dashboard/group/menu/schedule";

/**
 * The branch admin's own Schedule screens (Home calendar, Event, Event Type,
 * Holiday) without the Time Table, shown for whichever school is picked here.
 *
 * Those screens read and write the school the token is currently acting in, so
 * picking a school re-mints the token via the same call the header's branch
 * switcher makes (useGroupBranchSwitch) and reloads this page — nothing in the
 * screens themselves changes, which is what keeps them identical to the branch
 * admin's.
 */
const GroupSchedule = () => {
  const branches = useGroupBranchOptions();
  const { goToBranch, switching } = useGroupBranchSwitch();
  const actingSchoolId = useSelector(selectSchoolId);

  const current = branches.options.find(
    (o) => String(o.value) === String(actingSchoolId),
  );

  return (
    <>
      <div className="px-8 pt-8 flex items-center gap-3">
        <span className="font-medium text-gray-600">School</span>
        <Select
          showSearch
          optionFilterProp="label"
          placeholder="Select a school"
          aria-label="School"
          style={{ width: 280 }}
          options={branches.options}
          value={current?.value}
          loading={branches.isLoading || switching}
          disabled={switching}
          onChange={(schoolId) => {
            if (String(schoolId) !== String(actingSchoolId)) {
              goToBranch(schoolId, SCHEDULE_PATH);
            }
          }}
        />
      </div>
      {current ? (
        <SwitchSchedule hideTimeTable />
      ) : (
        !branches.isLoading && (
          <p className="px-8 pt-6 text-gray-500">
            Select a school to manage its schedule.
          </p>
        )
      )}
    </>
  );
};

export default GroupSchedule;
